import { get } from '../index';

// Per-company drill-in fetch. Replaces the heavyweight
// mainAdminGetCompanies() (now lightweight) for pages that actually
// need the full users + projects + timelines + sessions tree.
//
// Response shape:
//   { company: { ...full doc, users: [...with projects], plan: [...] },
//     projects: [...with timelines+sessions],
//     users:    [...with projects] }
export const mainAdminGetCompanyDetails = (companyId) => {
  return get(`/admin-panel/companies/${companyId}`);
};
